'use strict';

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:myCurrentTime
 * @description
 * # myCurrentTime
 */
angular.module('gfcmsApp')
  .directive('profile', function ($rootScope, appSettings, BaseService, AuthenticationService, eventsService) {
    return {
      templateUrl: '/views/profile.html',
      restrict: 'E',
      link: function postLink(scope) {

        var service = new BaseService();

        scope.profile = {};

        activate();

        function activate() {
          loadCachedProfile();
          $rootScope.$on(eventsService.profileUpdatedEvent, loadProfile);
        }

        function loadCachedProfile() {
          var profile = AuthenticationService.getUserInfo();

          if (!!profile) {
            scope.profile = profile;
            scope.profile.profilePictureUrl = !!scope.profile.profilePictureUrl ?
                          scope.profile.profilePictureUrl :
                          'images/ui-sam.jpg';
            return;
          }

          loadProfile();
        }

        function loadProfile() {
          service.http.get(service.baseUrl + '/account/userinfo')
          .then(function (results) {
            scope.profile = results.data;
            scope.profile.profilePictureUrl = !!scope.profile.profilePictureUrl ?
                          scope.profile.profilePictureUrl :
                          'images/ui-sam.jpg';
            // scope.lastName = results.lastName;
          })
          .catch(function (err)
          {
            // handle error
          });
        }
      }
    };
  });
